import React from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider, merge } from 'theme-ui';
import split from './split-slides';
import { Context } from './context';
import Keyboard from './keyboard';
import modes from './modes';
import Storage from './storage';
import Container from './container';
import Slide from './slide';
import baseTheme from './theme';
import { jsx as ___EmotionJSX } from "@emotion/core";

var getIndex = function getIndex(props) {
  if (!props.location) return 0;
  var n = Number(props.location.hash.replace(/^#/, ''));
  return n;
};

export default (function (props) {
  var slides = split(props);

  var _React$useState = React.useState(getIndex(props)),
      index = _React$useState[0],
      setIndex = _React$useState[1];

  var _ref = props.pageContext || {},
      slug = _ref.slug;

  var slide = slides[index];

  var _React$useState2 = React.useState(modes.default),
      mode = _React$useState2[0],
      setMode = _React$useState2[1];

  var toggleMode = function toggleMode(next) {
    return setMode(function (current) {
      return current === next ? modes.default : next;
    });
  };

  var _React$useState3 = React.useState(0),
      step = _React$useState3[0],
      setStep = _React$useState3[1];

  var _React$useState4 = React.useState(0),
      steps = _React$useState4[0],
      setSteps = _React$useState4[1];

  var lastIndex = React.useRef(0);
  var direction = index - lastIndex.current;
  React.useEffect(function () {
    lastIndex.current = index;
  }, [index]);
  React.useEffect(function () {
    if (props.location.pathname === '/print') return;
    props.navigate('/#' + index, {
      replace: true
    });
  }, [index]);
  React.useEffect(function () {
    if (props.location.pathname === '/print') {
      setMode(modes.print);
    }

    if (!slide) {
      props.navigate('/');
      setIndex(0);
    }
  }, []);
  if (!slide) return false;
  var context = {
    slides: slides,
    slug: slug,
    index: index,
    setIndex: setIndex,
    direction: direction,
    length: slides.length,
    slide: slide,
    mode: mode,
    setMode: setMode,
    toggleMode: toggleMode,
    notes: slide.notes,
    header: slides.header,
    footer: slides.footer,
    step: step,
    setStep: setStep,
    steps: steps,
    setSteps: setSteps
  };

  context.previous = function () {
    if (steps && step > 0) {
      setStep(function (n) {
        return n - 1;
      });
    } else {
      setIndex(function (n) {
        return n > 0 ? n - 1 : n;
      });
      setStep(0);
      setSteps(0);
    }
  };

  context.next = function () {
    if (step < steps) {
      setStep(function (n) {
        return n + 1;
      });
    } else {
      setIndex(function (n) {
        return n < slides.length - 1 ? n + 1 : n;
      });
      setStep(0);
      setSteps(0);
    }
  };

  var theme = merge(baseTheme, props.theme || {});
  return ___EmotionJSX(Context.Provider, {
    value: context
  }, ___EmotionJSX(Keyboard, null), ___EmotionJSX(Storage, null), ___EmotionJSX(Helmet, null, slides.head.children, theme.googleFont && ___EmotionJSX("link", {
    rel: "stylesheet",
    href: theme.googleFont
  })), ___EmotionJSX(ThemeProvider, {
    theme: theme,
    components: theme.components
  }, ___EmotionJSX(Container, null, ___EmotionJSX(Slide, null, slide))));
});